import { render, staticRenderFns } from "./AplicacaoSugestaoSelectModal.vue?vue&type=template&id=d194bd94&scoped=true"
import script from "./AplicacaoSugestaoSelectModal.vue?vue&type=script&lang=js"
export * from "./AplicacaoSugestaoSelectModal.vue?vue&type=script&lang=js"
import style0 from "./AplicacaoSugestaoSelectModal.vue?vue&type=style&index=0&id=d194bd94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d194bd94",
  null
  
)

export default component.exports